import firestar, {
   Actions,
   CollectionDescriptor,
   Root
} from 'firestar';
import Orders from './Orders';

export const SupportOptions = {
   'notDelivered': 'Gift not delivered',
   'other': 'Something else'
}

type SupportOptionType = keyof typeof SupportOptions

interface MessageType extends Root {
   message: string,
   source: 'user' | 'support' | 'assistant'
}

interface ChatType extends Root {
   title: string,
   subject: string,
   agent?: 'support' | 'assistant'
}

namespace Support {

   export type Chat = ChatType
   export type Message = MessageType
   export type SupportOption = SupportOptionType

   export function getChatsForOrder(orderId: string) {
      const path = `orders/${orderId}/chats`
      return Actions.readCollection<Chat>(path, {
         orderBy: {
            fieldPath: 'createdAt',
            directionStr: 'desc'
         }
      })
   }

   export function getChatWithId(orderId: string, chatId: string) {
      const path = `orders/${orderId}/chats/${chatId}`
      return Actions.readDocument<Chat>(path)
   }

   export function getMessagesForChat(
      orderId: string,
      chatId: string,
      descriptor?: CollectionDescriptor
   ) {
      const path = `orders/${orderId}/chats/${chatId}/messages`
      return Actions.readCollection<Message>(path, {
         orderBy: {
            fieldPath: 'createdAt',
            directionStr: 'asc'
         },
         limit: 100,
         ...descriptor
      })
   }

   export function observeMessages(
      orderId: string,
      chatId: string,
      callback: any,
      descriptor?: CollectionDescriptor,
   ) {
      const path = `orders/${orderId}/chats/${chatId}/messages`
      return Actions.listenCollection(path, callback, descriptor ?? {})
   }

   export function sendMessageForOrder(
      orderId: string,
      chatId: string,
      message: Message
   ) {
      const path = `orders/${orderId}/chats/${chatId}/messages`
      return Actions.addToCollection(path, message)
   }

   export function createChat(orderId: string, chat: Chat) {
      const path = `orders/${orderId}/chats`
      return Actions.addToCollection(path, chat)
   }

   export function markAsRead(
      orderId: string,
      userId: string
   ) {
      return new Promise<Orders.Order | undefined>(async (resolve, reject) => {
         try {
            let orderResponse = await Orders.getOrder(orderId)
            const userInfo = orderResponse?.userInfo
            const payload = {} as {[key: string] : any }
            if (userInfo?.uid === userId) {
               payload['chats.unread.user'] = 0
            } else {
               payload['chats.unread.support'] = 0
            }
            await Orders.updateOrder(orderId, payload)
            orderResponse = await Orders.getOrder(orderId)
            resolve(orderResponse)
         } catch (error) {
            reject(error)
         }
      })
   }

   export function incrementUnreadCount(
      orderId: string,
      userId: string
   ) {
      return new Promise<void>(async (resolve, reject) => {
         try {
            const firestore = firestar.getFirestore()
            const incrementValue = firestore.FieldValue.increment(1)
            let orderResponse = await Orders.getOrder(orderId)
            const payload = {} as {[key: string] : any }
            const userInfo = orderResponse?.userInfo
            if (userInfo?.uid !== userId) {
               payload['chats.unread.user'] = incrementValue
            } else {
               payload['chats.unread.support'] = incrementValue
            }
            payload['chats.updatedAt'] = firestore.Timestamp.now()
            await Orders.updateOrder(orderId, payload)
            resolve()
         } catch (error) {
            reject(error)
         }
      })
   }

}

export default Support